import React from 'react';
import { FadeIn } from '../ui/FadeIn';
import { CTAButton } from '../ui/CTAButton';
import { CheckCircle2 } from 'lucide-react';
export function OfferSection() {
  return <section id="offer-section" className="py-24 px-6 bg-white" data-id="element-111">
      <div className="max-w-5xl mx-auto" data-id="element-112">
        <FadeIn data-id="element-113">
          <div className="bg-cream rounded-3xl p-8 md:p-12 shadow-2xl border border-amber/20 overflow-hidden relative" data-id="element-114">
            <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-115">
              <div data-id="element-116">
                <h2 className="text-3xl md:text-4xl font-bold text-forest mb-6" data-id="element-117">
                  Tus riñones son tu filtro de vida.
                </h2>
                <p className="text-xl text-gray-700 mb-8 leading-relaxed" data-id="element-118">
                  Si ellos se detienen, tu vida se detiene. Este no es un gasto,
                  es una inversión en tu autonomía.
                </p>

                <div className="bg-white p-6 rounded-2xl shadow-inner mb-6 border border-gray-100" data-id="element-119">
                  <p className="text-lg text-gray-600 mb-4" data-id="element-120">
                    Obtén el Protocolo de Rescate para Tus Riñones con todos los
                    anexos incluidos hoy mismo.
                  </p>

                  <div className="space-y-3 mb-6" data-id="element-121">
                    <div className="flex items-start gap-3" data-id="element-122">
                      <CheckCircle2 className="w-5 h-5 text-green-500 shrink-0 mt-0.5" data-id="element-123" />
                      <p className="text-gray-700" data-id="element-124">
                        <span className="font-semibold" data-id="element-125">
                          Protocolo Maestro de 14 Días para tus Riñones
                        </span>{' '}
                        (Valor: $27)
                      </p>
                    </div>
                    <div className="flex items-start gap-3" data-id="element-126">
                      <CheckCircle2 className="w-5 h-5 text-green-500 shrink-0 mt-0.5" data-id="element-127" />
                      <p className="text-gray-700" data-id="element-128">
                        <span className="font-semibold" data-id="element-129">
                          Recetario 'Sabor Renal' con 50 Recetas
                        </span>{' '}
                        (Valor: $37)
                      </p>
                    </div>
                    <div className="flex items-start gap-3" data-id="element-130">
                      <CheckCircle2 className="w-5 h-5 text-green-500 shrink-0 mt-0.5" data-id="element-131" />
                      <p className="text-gray-700" data-id="element-132">
                        <span className="font-semibold" data-id="element-133">
                          Guía de Hidratación Osmótica de Precisión
                        </span>{' '}
                        (Valor: $15)
                      </p>
                    </div>
                    <div className="flex items-start gap-3" data-id="element-134">
                      <CheckCircle2 className="w-5 h-5 text-green-500 shrink-0 mt-0.5" data-id="element-135" />
                      <p className="text-gray-700" data-id="element-136">
                        <span className="font-semibold" data-id="element-137">
                          BONO 1: Guía de Análisis de Sangre
                        </span>{' '}
                        (Valor: $12)
                      </p>
                    </div>
                    <div className="flex items-start gap-3" data-id="element-138">
                      <CheckCircle2 className="w-5 h-5 text-green-500 shrink-0 mt-0.5" data-id="element-139" />
                      <p className="text-gray-700" data-id="element-140">
                        <span className="font-semibold" data-id="element-141">
                          BONO 2: Lista de Compras Antiestrés
                        </span>{' '}
                        (Valor: $10)
                      </p>
                    </div>
                    <div className="flex items-start gap-3" data-id="element-142">
                      <CheckCircle2 className="w-5 h-5 text-green-500 shrink-0 mt-0.5" data-id="element-143" />
                      <p className="text-gray-700" data-id="element-144">
                        <span className="font-semibold" data-id="element-145">
                          BONO 3: Diario de Monitoreo Renal
                        </span>{' '}
                        (Valor: $7)
                      </p>
                    </div>
                  </div>

                  <div className="border-t border-gray-100 pt-4 text-center" data-id="element-146">
                    <p className="text-gray-500 line-through mb-1" data-id="element-147">
                      Valor Total: $108.00
                    </p>
                    <p className="text-xl font-bold text-forest" data-id="element-148">
                      Hoy por solo:
                    </p>
                    <p className="text-6xl font-black text-amber mt-1" data-id="element-149">
                      $15 USD
                    </p>
                  </div>
                </div>

                <CTAButton className="w-full text-lg md:text-xl py-6" onClick={() => {
                if (window.fbq) {
                  window.fbq('track', 'AddToCart', {
                    content_name: 'Protocolo de Rescate Renal',
                    content_type: 'product',
                    value: 15,
                    currency: 'USD'
                  });
                }
                window.open('https://www.tres33group.com/cart/43089344135229:1', '_blank');
              }} data-id="element-150">
                  ¡SÍ, QUIERO MI CUPO Y MIS BONOS POR SOLAMENTE $15!
                  <span className="block text-sm font-normal mt-1 opacity-90" data-id="element-151">
                    (Acceso inmediato al PDF y todos los materiales por solo
                    $15)
                  </span>
                </CTAButton>
              </div>

              <div className="relative rounded-2xl overflow-hidden shadow-xl border-4 border-white" data-id="element-152">
                <img src="https://cdn.magicpatterns.com/uploads/jJtAf6N5nAkiVAVHSkyMLJ/Rescate_renal_y_bienestar_personal.png" alt="Hombre relajado bebiendo agua con limón y leyendo el protocolo" className="w-full h-auto object-cover" data-id="element-153" />
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}